import { takeEvery, call, put } from 'redux-saga/effects'
import { getStatus } from 'services/support'
import { receiveStatus, failedReceiveStatus } from 'models/support/actions'
import { REQUEST_STATUS } from 'models/actionTypes'

export function* requestStatusSaga() {
    try {
        const { data } = yield call(getStatus)
        yield put(receiveStatus(data))
    } catch (error) {
        yield put(failedReceiveStatus())
    }
}

export function* watchRequestStatus() {
    yield takeEvery(REQUEST_STATUS, requestStatusSaga)
}

export const supportSagas = [watchRequestStatus()]
